import { TableHead, TableHeader, TableRow } from '@bpinternal/ui-kit-next'
import { SquareX } from 'lucide-react'
import { ReactNode } from 'react'
import { KnowledgeSourceDeleteButton } from './KnowledgeSourceDeleteButton'
import { useKnowledgeSourceSelection } from './KnowledgeSourceSelectionContext'

type SharedKnowledgeSourceTableHeaderProps = {
  workspaceId: string
  botId: string
  kbId: string
  totalItems: number
  knowledgeSourceIds?: string[]
  showOrigin?: boolean
  children?: ReactNode
}

export const KnowledgeSourceTableHeader = ({
  workspaceId,
  botId,
  kbId,
  totalItems,
  knowledgeSourceIds,
  children,
}: SharedKnowledgeSourceTableHeaderProps) => {
  const { selectedKnowledgeSources, selectedKnowledgeSourcesCount, clearSelectedKnowledgeSources } =
    useKnowledgeSourceSelection()

  return (
    <div className="flex h-9 w-full items-center justify-between gap-4">
      {selectedKnowledgeSourcesCount > 0 ? (
        <KnowledgeSourceDeleteButton
          workspaceId={workspaceId}
          botId={botId}
          kbId={kbId}
          knowledgeSourceIds={knowledgeSourceIds || [...selectedKnowledgeSources.knowledgeSource]}
          webPageSourceIds={[...selectedKnowledgeSources.webPageSource]}
          selectedKnowledgeSourcesCount={selectedKnowledgeSourcesCount}
          onSuccess={() => {
            clearSelectedKnowledgeSources()
          }}
        />
      ) : (
        <div></div>
      )}
      <div className="flex items-center gap-4">
        {children}
        <p className="text-sm font-medium text-foreground">{totalItems} Items</p>
      </div>
    </div>
  )
}

export const KnowledgeSourceTableHeaderRow = ({ showOrigin = false }: { showOrigin?: boolean }) => {
  const { selectedKnowledgeSourcesCount, clearSelectedKnowledgeSources } = useKnowledgeSourceSelection()

  return (
    <TableHeader>
      <TableRow className="hover:bg-transparent">
        <TableHead className="w-10 px-0 pl-2">
          {selectedKnowledgeSourcesCount > 0 && (
            <div className="flex items-center justify-center">
              <SquareX size={16} color="red" onClick={clearSelectedKnowledgeSources} className=" cursor-pointer" />
            </div>
          )}
        </TableHead>
        <TableHead>Name</TableHead>
        {showOrigin && <TableHead>Origin</TableHead>}
        <TableHead>Last Updated</TableHead>
        <TableHead>Size</TableHead>
        <TableHead>Status</TableHead>
      </TableRow>
    </TableHeader>
  )
}
